<template>
  <el-dialog
    :title="title"
    :visible="visibleModalName !== null"
    width="50%"
    custom-class="day-add-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <el-form ref="dataForm" :model="dataForm" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="Сумма платежа"
            prop="sum"
            style="margin-right: 4px"
          >
            <el-input
              v-model="dataForm.sum"
              type="number"
              :rows="5"
              :readonly="dataForm.payment_type == 0"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Всего платежей"
            prop="paymentCount"
            style="margin-left: 4px"
          >
            <el-input
              v-model="dataForm.paymentCount"
              :readonly="true"
              type="number"
              :rows="5"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="dataForm.payment_type == 2">
        <el-col :span="24">
          <el-form-item
            label="Комментарий"
            prop="sumPayments"
            style="margin-right: 4px"
          >
            <el-input v-model="dataForm.comment" type="textarea" :rows="5" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="dataForm.payment_type == 1">
        <p>
          Итого сумма аванса:
          {{ dataForm.paymentCount * dataForm.sum }} рублей
        </p>
      </el-row>
      <el-row v-if="dataForm.payment_type == 2">
        <p>
          Итого сумма дополнительного платежа:
          {{ dataForm.paymentCount * dataForm.sum }} рублей
        </p>
      </el-row>
      <el-row v-if="dataForm.payment_type == 0">
        <p v-if="hasNegativeItem" class="dialog-text-alarm">
          Один или несколько выбранных пунктов имеют максимальную окончательную
          сумму платежа 0
        </p>
        <p>
          Итого сумма окончательного расчета:
          {{ dataForm.sum > 0 ? formattedSelectedDebt : 0 }} рублей
        </p>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="secondary"
        :loading="requestLoading"
        @click="beforeClose"
      >
        Отменить
      </el-button>
      <el-button
        :disabled="hasNegativeItem && dataForm.payment_type == 0"
        type="primary"
        :loading="requestLoading"
        @click="submitForm('dataForm')"
      >
        Отправить в оплату
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formattedNumberDecimal } from '@/helpers/functions'
import { mapActions, mapMutations } from 'vuex'
import { registerMenuItems } from '@/views/RegisterOfPayments/constants'

export default {
  name: 'RegisterAddPayment',
  props: {
    selectedDebt: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    visibleModalName: {
      type: String || null,
      default: null,
    },
  },
  data() {
    return {
      title: '',
      rules: {
        sum: [
          {
            required: true,
            message: 'Заполните cумму',
            trigger: 'change',
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > this.maxPayed && this.dataForm.payment_type === 1) {
                callback(
                  new Error(
                    `Один или несколько выбранных пунктов имеют максимальную окончательную сумму платежа ${this.maxPayed}`,
                  ),
                )
              }

              return callback()
            },

            trigger: 'change',
          },
        ],
      },
      dataForm: {
        response_ids: [],
        payment_type: 0,
        status: 0,
        comment: '',
        sum: null,
        paymentCount: 1,
      },
      requestLoading: false,
    }
  },
  computed: {
    formattedSelectedDebt() {
      return formattedNumberDecimal(this.selectedDebt)
    },
    hasNegativeItem() {
      let negative = false

      this.items.map(item => {
        item?.payments_left < 0 ? (negative = true) : null
      })

      return negative
    },

    maxPayed() {
      let payments_left_arr = []

      this.items.map(item => {
        payments_left_arr.push(
          item?.payments_left < 0 ? 0 : item?.payments_left,
        )
      })

      return Math.min(...payments_left_arr)
    },
  },
  methods: {
    ...mapActions({
      createPayment: 'tableOfPayments/createPayment',
      createMassPayments: 'tableOfPayments/createMassPayments',
    }),
    ...mapMutations({
      addPayment: 'registerOfPayments/updateRegisterItem',
    }),

    submitForm(formName) {
      this.requestLoading = true

      this.$refs[formName].validate(valid => {
        if (valid) {
          const {
            response_ids,
            payment_type,
            sum,
            status,
            comment,
            paymentCount,
          } = this.dataForm

          if (paymentCount === 1) {
            this.createPayment({
              response_id: response_ids[0],
              payment_type,
              sum,
              status,
              comment,
            })
              .then(res => {
                this.$message({
                  message: 'Платеж создан',
                  type: 'success',
                })
                this.addPayment(res.data.data)

                this.requestLoading = false
                this.beforeClose()
              })
              .catch(e => {
                this.requestLoading = false
                this.$message.error(`Ошибка! ${e.message} `)
              })
          } else {
            this.createMassPayments({
              response_ids,
              payment_type,
              sum,
              status,
              comment,
            })
              .then(res => {
                this.$message({
                  message: 'Платежи созданы',
                  type: 'success',
                })
                this.addPayment(res.data.data)
                this.requestLoading = false
                this.beforeClose()
              })
              .catch(e => {
                this.requestLoading = false
                this.$message.error(`Ошибка! ${e.message} `)
              })
          }
        } else {
          this.requestLoading = false

          return false
        }
      })
    },
    beforeOpen() {
      let modal = registerMenuItems.filter(
        item => item.name === this.visibleModalName,
      )

      this.title = modal[0].title
      this.dataForm.payment_type = modal[0].typePayment
      this.dataForm.payment_type === 0
        ? (this.dataForm.sum = this.selectedDebt < 0 ? 0 : this.selectedDebt)
        : null
      this.dataForm.paymentCount = this.items.length
      this.items.length === 1
        ? this.dataForm.response_ids.push(this.items[0].response_id)
        : this.items.map(item =>
            this.dataForm.response_ids.push(item.response_id),
          )
    },
    beforeClose() {
      this.$emit('close')
      this.dataForm = {
        response_ids: [],
        payment_type: 0,
        status: 0,
        comment: '',
        sum: 0,
        paymentCount: 1,
      }
    },
  },
}
</script>

<style lang="sass">
.day-add-modal
  .dialog-text-alarm
    color: red
  .el-form-item__content
    line-height: 1
  .el-input-number, .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
</style>
